import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceChartComponent } from './service-chart/service-chart.component';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';

const routes: Routes = [
  {
    path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
      path: "service", component: ServiceChartComponent, data: { module: "Dashboard", accion: "Servicios" }
    }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChartRoutingModule { }
